import { render, staticRenderFns } from "./VendorEmails.vue?vue&type=template&id=00431384"
import script from "./VendorEmails.vue?vue&type=script&lang=js"
export * from "./VendorEmails.vue?vue&type=script&lang=js"
import style0 from "./VendorEmails.vue?vue&type=style&index=0&id=00431384&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports